import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import CryptoInvoicesTable from '../CryptoInvoicesTable'
import CreatePrepaymentButton from '../CreatePrepaymentButton'
import type { CryptoInvoiceData } from '../../type'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'

interface CryptoInvoicesListingProps {
	data: CryptoInvoiceData[]
	total: number
	isLoading?: boolean
}

export default function CryptoInvoicesListing({
	data,
	total,
	isLoading = false,
}: CryptoInvoicesListingProps) {
	return (
		<Card>
			<CardHeader>
				<div className="flex items-center justify-between gap-4">
					<CardTitle>รายการใบแจ้งหนี้รายเดือน</CardTitle>
					<div className="flex items-center gap-3">
						<div className="text-sm text-muted-foreground">
							ทั้งหมด {total} รายการ
						</div>
						<CreatePrepaymentButton />
					</div>
				</div>
			</CardHeader>
			<CardContent>
				<div className="mb-4 flex">
					<DataTableSearch placeHolder="ค้นหา Transaction ID..." />
					<DataTableResetFilter />
				</div>

				<CryptoInvoicesTable data={data} isLoading={isLoading} />
			</CardContent>
		</Card>
	)
}
